import script from "./LiquorOrderingNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./LiquorOrderingNavBar.vue?vue&type=script&setup=true&lang=js"

import "./LiquorOrderingNavBar.vue?vue&type=style&index=0&id=7571a9c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7571a9c5"]])

export default __exports__